import React, { useState } from "react";
import Header from "../../components/Header";
import Styles from "./index.module.scss";
import { Badge } from "antd";
import TimeTable from "./TimeTable";
import List from "./List";
import { isTrue } from "../../service/service";
import { useAtomValue } from "jotai";
import { RateOtherAtom } from "./Store";
import classNames from "classnames";

const Index = () => {
    const [query, setQuery] = useState("2");

    const { flag: MyDotFlag } = useAtomValue(RateOtherAtom);

    return (
        <div>
            <Header />
            <div className={Styles.root}>
                <div className={Styles.tabs}>
                    <span
                        className={classNames(Styles.tabItem, {
                            [Styles.active]: query === "1"
                        })}
                        onClick={() => setQuery("1")}>
                        课程时间表
                    </span>
                    <span
                        className={classNames(Styles.tabItem, {
                            [Styles.active]: query === "2"
                        })}
                        onClick={() => setQuery("2")}>
                        <Badge dot={isTrue(MyDotFlag)}>评价课程列表</Badge>
                    </span>
                </div>
                <div>
                    {query === "1" && <TimeTable />}
                    {query === "2" && <List />}
                </div>
            </div>
        </div>
    );
};

export default Index;
